import React from "react";
import "./CarouselWrapper.css";
import Carousel from "react-bootstrap/Carousel";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import 'swiper/css/scrollbar';

function CarouselWrapper() {
  const banner1 = require("../assets/banner/Grandslam-Banner-1.png");



  return (
    <div className="carousel-wrapper">
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        loop={true}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
        }}
        modules={[Pagination, Navigation, Autoplay]}
        className="mySwiper"
      >
        <SwiperSlide>
          <img
            src={banner1}
            // className="d-block w-100 desk_img"
            alt="First Slide"
          />
        </SwiperSlide>

      </Swiper>

      {/*<Carousel slide={true}>*/}
      {/*  <div id="carousel" className="carousel slide" data-bs-ride="carousel">*/}
      {/*    <div className="carousel-inner">*/}
      {/*      <Carousel.Item>*/}
      {/*      <Carousel.Caption>*/}
      {/*          <h1>This is image 1</h1>*/}
      {/*        </Carousel.Caption>*/}
      {/*        /!* <div className="carousel-item active"> *!/*/}
      {/*          <img*/}
      {/*            src={banner1}*/}
      {/*            className="d-block w-100 desk_img"*/}
      {/*            alt="First Slide"*/}
      {/*          />*/}
      {/*          /!* <img*/}
      {/*            src={require("../assets/banner/toonz-ad-banner.jpg")}*/}
      {/*            className="d-block w-100 mob_img"*/}
      {/*            alt="..."*/}
      {/*          /> *!/*/}
      {/*        /!* </div> *!/*/}
      {/*      </Carousel.Item>*/}

      {/*      <Carousel.Item>*/}
      {/*        /!* <div className="carousel-item"> *!/*/}
      {/*        <Carousel.Caption>*/}
      {/*          <h1>This is image 2</h1>*/}
      {/*        </Carousel.Caption>*/}
      {/*          <img*/}
      {/*            src={require("../assets/banner/toonz-ad-banner.jpg")}*/}
      {/*            className="d-block w-100 desk_img"*/}
      {/*            alt="Second Slide"*/}
      {/*          />*/}
      {/*          /!* <img*/}
      {/*            src={require("../assets/banner/toonz-ad-banner.jpg")}*/}
      {/*            className="d-block w-100 mob_img"*/}
      {/*            alt="..."*/}
      {/*          /> *!/*/}
      {/*        /!* </div> *!/*/}
      {/*      </Carousel.Item>*/}

      {/*      /!* <div className="carousel-item">*/}
      {/*        <img*/}
      {/*          src="./assets/banner/DClub_3_1632x544.jpg"*/}
      {/*          className="d-block w-100 desk_img"*/}
      {/*          alt="..."*/}
      {/*        />*/}
      {/*        <img*/}
      {/*          src="./assets/banner/Dclub_3_686x1080.jpg"*/}
      {/*          className="d-block w-100 mob_img"*/}
      {/*          alt="..."*/}
      {/*        />*/}
      {/*      </div> *!/*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</Carousel>*/}
    </div>
  );
}

export default CarouselWrapper;
